import _isEmpty from 'lodash/isEmpty';
import * as React from 'react';
import { TabPanel, Tabs } from '../tabs';

export const PAGE_TAB_SEARCH_RESULTS_LOAD_MORE = 15;

interface PageTabsProps {
  children: JSX.Element | JSX.Element[];
  showAllTab?: boolean;
  className?: string;
  onTabSelect?: (tabLabel: string) => void;
  selectedTabKey?: string;
}

/* {showAllTab} to handle default view of ALL tab.
 * Using normal Tabs component was not able to render the sub tabs component with useQuery or asynchronous methods.
 * Hide “All” tab for child component using Child Tabs.
 */
export const PageTabs = ({ children, showAllTab = true, className, onTabSelect, selectedTabKey }: PageTabsProps) => {
  // remove tabs that are disabled (permission or feature flag)
  const enabledChildren = React.Children.map(children, (child) => {
    if (child === null) {
      return;
    }
    if (!child.props.disabled) {
      return child;
    }
    return;
  });

  // if there is only one tab. render it as a table
  if (React.Children.toArray(enabledChildren).length === 1) {
    return <div>{enabledChildren}</div>;
  }

  // else go through each child and make them tab panels.
  const childTabs = React.Children.map(enabledChildren, (child) => {
    if (child) {
      const { label } = child.props;
      return <TabPanel label={label}>{child}</TabPanel>;
    }
  });

  // add on the 'all' tab
  if (showAllTab && childTabs && !_isEmpty(childTabs)) {
    childTabs.unshift(
      <TabPanel label="View all" key={'View all'}>
        {enabledChildren}
      </TabPanel>
    );
  }
  return (
    <Tabs className={className} onTabSelect={onTabSelect} selectedTabKey={selectedTabKey}>
      {childTabs}
    </Tabs>
  );
};
